import { AnyVariables, OperationResult } from 'urql';

import { UpdateInCartVariables } from 'hooks/useCart';
import { ActiveCart, ActiveCartItem } from 'types/cart';
import {
  AnalyticsEvents,
  event,
  transformListProductToAnalyticsItem,
} from 'utils/analytics';
import { UpdateItemInCartMutation } from '__generated__/graphql';

import { SelectedItemType } from '../types';

// Update quantity of items one at a time to keep cart in sync
export const handleUpdateQuantity = async (
  itemsToUpdate: SelectedItemType[],
  cart: ActiveCart,
  doesSelectedItemMatchInCartItemCallback: (
    selected: SelectedItemType,
    inCart: ActiveCartItem
  ) => boolean,
  updateInCart: (
    variables: UpdateInCartVariables
  ) => Promise<OperationResult<UpdateItemInCartMutation, AnyVariables>>,
  currencyCode: string
): Promise<
  OperationResult<UpdateItemInCartMutation, AnyVariables> | undefined
> => {
  if (!cart?.products) return;

  let res: OperationResult<UpdateItemInCartMutation, AnyVariables> | undefined =
    undefined;
  for (const itemToUpdate of itemsToUpdate) {
    const itemToUpdateInCart = cart.products.find(inCartItem =>
      doesSelectedItemMatchInCartItemCallback(itemToUpdate, inCartItem)
    );
    if (!itemToUpdateInCart) return;
    res = await updateInCart({
      itemId: itemToUpdateInCart.id,
      quantity: itemToUpdate.quantity,
      masterId: itemToUpdate.id,
    });
    if (res.data?.updateItemInCart) {
      const analyticsItem = transformListProductToAnalyticsItem({
        product: itemToUpdate,
        currency: currencyCode,
        quantity: itemToUpdate.quantity,
        categories: {
          item_category: undefined,
        },
        itemListId: undefined,
        itemListName: undefined,
        index: undefined,
        size: itemToUpdate.size.label,
      });
      event(AnalyticsEvents.GA4EC_AddItemToCart, {
        event_name: AnalyticsEvents.ADD_ITEM_LIST_TO_CART,
        ecommerce: {
          item_list_id: undefined,
          item_list_name: undefined,
          currency: currencyCode,
          value: undefined,
          item_id_ep: itemToUpdate.id,
          item_name_ep: itemToUpdate.productName,
          image_type: undefined,
          image_number: undefined,
          items: [analyticsItem],
        },
      });
    }
  }

  return res;
};
